import { combineReducers } from 'redux';

import dialogsContactUs from './dialogContactUs';

const reducer = combineReducers({
  [dialogsContactUs.name]: dialogsContactUs.reducer,
});

export default reducer;
